import React from "react";
import { Stack, Text } from "@origin-digital/ods-core";

import {
  PopularCategories,
  PopularCategoriesSkeleton,
} from "../../../../components/PopularCategories";
import { OtherCategories } from "../../../../components/PopularCategories/OtherCategories";
import { content } from "./content";
import { useCategories } from "../../../../hooks";

const POPULAR_CATEGORIES_COUNT = 3;

export const CategoriesSection: React.FC = () => {
  const { categories, loading, error } = useCategories();
  const popularCategories = categories.slice(0, POPULAR_CATEGORIES_COUNT);
  const otherCategories = categories.slice(POPULAR_CATEGORIES_COUNT);

  return (
    <Stack space={{ xs: "medium", lg: "large" }} data-id="categories-section">
      {loading && <PopularCategoriesSkeleton />}

      {!loading && !error && categories.length === 0 && (
        <Text>{content.emptyStateMessage}</Text>
      )}

      {!loading && !error && popularCategories.length > 0 && (
        <PopularCategories categories={popularCategories} />
      )}

      {!loading && !error && otherCategories.length > 0 && (
        <OtherCategories categories={otherCategories} />
      )}

      {/* Error state is handled globally by ErrorBoundary via hook throws. */}
    </Stack>
  );
};
